// extracted by mini-css-extract-plugin
module.exports = {"container":"_2OMZu3D9","contact":"_3vIrl424","map":"Hf3JJt1s","title":"EbVWbRlJ","address":"_2cMk05Wx"};